export const LICENSE_IMAGE_ACCEPT_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];
export const LICENSE_ACCEPT_TYPES_WITH_PDF = [...LICENSE_IMAGE_ACCEPT_TYPES, 'application/pdf'];
